module.exports = __webpack_public_path__ + "img/icon_voice@2x.f34d3ba6.png";